import React, { useEffect, useState } from "react";
import { FaTimesCircle } from "react-icons/fa";
import CryptoRate from "./CryptoRate";
import PointRate from "./PointRate";
import GiftcardRateFlow from "./GiftcardRateFlow";
import CardModal from "./CardModal";
import UploadCardImage from "../UploadCardImage";
import ExpandAdd from "./ExpandAdd";
import {
  useGiftCardDetailQuery,
  useGiftCardsListQuery,
  useInvalidateGiftCardCatalog,
} from "../../../lib/api/useGiftCardCatalogQueries";

const NewRateFlow = ({ setUploadGiftcard, rateScreen, setRateScreen }: any) => {
  const [cardModal, setCardModal] = useState<boolean>(false);
  const [cardId, setCardId] = useState<string>("");
  const [uploadCardImage, setUploadCardImage] = useState<boolean>(false);
  const [addGiftcard, setAddGiftcard] = useState<boolean>(false);
  const invalidateCatalog = useInvalidateGiftCardCatalog();

  const giftTabActive = rateScreen === 2;

  const { data: allGiftcards = [] } = useGiftCardsListQuery("all", {
    enabled: giftTabActive,
  });

  const {
    data: cardDetails = null,
    isPending: detailLoading,
    isError: detailIsError,
    refetch: refetchDetail,
  } = useGiftCardDetailQuery(cardId, { enabled: giftTabActive && Boolean(cardId) });

  useEffect(() => {
    if (rateScreen === 2) setCardModal(true);
    else setCardModal(false);
  }, [rateScreen]);

  return (
    <div className="w-full pt-8 text-white font-manrope pb-8 h-screen px-6 lgss:px-12  bg-[#13181B]">
      <div className="flex justify-end items-center">
        <FaTimesCircle
          onClick={() => {
            setUploadGiftcard(false);
          }}
          className="text-[#78C2F7] text-[24px] cursor-pointer"
        />
      </div>
      <div className="mt-8">
        <div className="justify-start items-center flex gap-8">
          <button
            type="button"
            onClick={() => setRateScreen(1)}
            className={
              rateScreen === 1
                ? "border-b border-secondary_button text-secondary_button text-[18px] font-semibold h-[48px]"
                : " text-[#C6D0D7] text-[16px] font-medium h-[48px]"
            }
          >
            Crypto
          </button>
          <button
            type="button"
            onClick={() => setRateScreen(2)}
            className={
              rateScreen === 2
                ? "border-b border-secondary_button text-secondary_button text-[18px] font-semibold h-[48px]"
                : " text-[#C6D0D7] text-[16px] font-medium h-[48px]"
            }
          >
            Giftcard
          </button>
          <button
            type="button"
            onClick={() => setRateScreen(3)}
            className={
              rateScreen === 3
                ? "border-b border-secondary_button text-secondary_button text-[18px] font-semibold h-[48px]"
                : " text-[#C6D0D7] text-[16px] font-medium h-[48px]"
            }
          >
            Point
          </button>
        </div>
        <div className="w-full rounded-full h-[1px] bg-[#3A4852]" />
        <div className="w-full mt-8 pb-20">
          {rateScreen === 1 ? (
            <CryptoRate />
          ) : rateScreen === 2 ? (
            <GiftcardRateFlow
              setCardModal={setCardModal}
              cardId={cardId}
              allGiftcards={allGiftcards}
              cardDetails={cardDetails}
              detailLoading={detailLoading}
              detailError={detailIsError}
              onRetryDetail={() => void refetchDetail()}
              setAddGiftcard={setAddGiftcard}
            />
          ) : rateScreen === 3 ? (
            <PointRate />
          ) : null}
        </div>
      </div>
      {cardModal ? (
        <CardModal
          cardId={cardId}
          onSelectCard={setCardId}
          setUploadCardImage={setUploadCardImage}
          setCardModal={setCardModal}
        />
      ) : null}
      {uploadCardImage ? (
        <UploadCardImage
          setUploadCardImage={setUploadCardImage}
          setCardModal={setCardModal}
          onCatalogChanged={() => invalidateCatalog()}
        />
      ) : null}
      {addGiftcard ? (
        <ExpandAdd setAddGiftcard={setAddGiftcard} cardDetails={cardDetails} />
      ) : null}
    </div>
  );
};

export default NewRateFlow;
